import React, { useEffect, useState } from "react";
import "./App.css";
import Login from "./components/Login/Login";
import Otp from "./components/Otp/Otp";
import HomePage from "./components/HomePage/HomePage";
import { Route, Routes, Navigate, useNavigate,useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Email from "./components/Email/Email";
// ✅ Auth utility functions
const isLoggedIn = () => !!localStorage.getItem("userToken");

// 🔐 AuthRoute with effect
function AuthRoute({ children }) {
  const loggedIn = isLoggedIn();

  if (!loggedIn) {
    toast.error("Please login first!");
    return <Navigate to="/login" replace />;
  }

  return children;
}


// 🔐 FullProtectedRoute with effect

function FullProtectedRoute({ children }) {
  const [authChecked, setAuthChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userToken = localStorage.getItem("userToken");
    const otpVerified = localStorage.getItem("isOtpVerfied") == "true";

    if (!userToken) {
      toast.error("Please login first!");
      navigate("/login", { replace: true });
    } else if (!otpVerified) {
      toast.error("OTP verification required!");
      navigate("/otp", { replace: true });
    } else {
      setAuthChecked(true);
    }
  }, [navigate]);

  return authChecked ? children : null;
}




function App() {
  return (
    <>
      <ToastContainer position="top-center" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/otp" element={<AuthRoute><Otp /></AuthRoute>} />
        <Route path="/home" element={<FullProtectedRoute><HomePage /></FullProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}


export default App;
